/* A large (full width) image or video */

import React from "react";
import PropTypes from "prop-types";

import styles from "./ImageBlock.module.scss";

export default function ImageBlock({ src, alt, attribution, ...props }) {
  return (
    <div className={styles.grid}>
      <div className={styles.container}>
        <img src={src + "?fm=webp&w=1920&q=80"} alt={alt} {...props} />
        {attribution?.trim?.() && <div className={styles.attribution}>{attribution}</div>}
      </div>
    </div>
  );
}

ImageBlock.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  attribution: PropTypes.node,
};
